// extracted by mini-css-extract-plugin
export default {"container":"SaveTrackStatisticsBtn_container__5d82F","isLoading":"SaveTrackStatisticsBtn_isLoading__2-uk6","rotate":"SaveTrackStatisticsBtn_rotate__ZULS7"};